import { useHttpClient } from '@/common/api/httpClient';
import type { FeatureFlagResponse } from './models/featureFlagResponse';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';

export interface ReadFeatureFlagResponse {
  ok: true;
  featureFlag: FeatureFlagResponse;
}

export function useReadFeatureFlags() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('featureflag'), {
      headers,
    });

    const text = translations.value.featureFlags.actions.read;

    const response = await httpClient.action<ReadFeatureFlagResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = (await response.json()) as FeatureFlagResponse;
        return {
          ok: true,
          featureFlag: json,
        };
      },
    });

    return response;
  }
}
